var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"load-more is-size-7"},[(_vm.showButton || _vm.isLoading)?_c('button',{staticClass:"button is-small",class:{
            'is-loading': _vm.isLoading,
            'is-danger': _vm.hasError
        },on:{"click":_vm.loadMore}},[_vm._v(" "+_vm._s(_vm.hasError ? 'Error. Click to retry.' : _vm.$t('showMore'))+" ")]):(_vm.hasPaginatedCurrentList)?_c('div',[_vm._v(" "+_vm._s(_vm.$t('allPostsLoaded'))+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }